import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Planning } from './planning.model';

export const PlanningActions = createActionGroup({
  source: 'Planning/API',
  events: {
    'Load Plannings': props<{ plannings: Planning[] }>(),
    'Add Planning': props<{ planning: Planning }>(),
    'Upsert Planning': props<{ planning: Planning }>(),
    'Add Plannings': props<{ plannings: Planning[] }>(),
    'Upsert Plannings': props<{ plannings: Planning[] }>(),
    'Update Planning': props<{ planning: Update<Planning> }>(),
    'Update Plannings': props<{ plannings: Update<Planning>[] }>(),
    'Delete Planning': props<{ id: string }>(),
    'Delete Plannings': props<{ ids: string[] }>(),
    'Clear Plannings': emptyProps()
  }
});
